import {activateYandexMetrika, activateTop100} from '@rambler-id/metrics'

const TOP100_KEY = 3115342
const YANDEX_METRIKA_ID_KEY = 29123130
const YANDEX_METRIKA_PORTAL_KEY = 26649402

export const activateMetrics = async () => {
  await Promise.all([
    activateYandexMetrika([
      {key: YANDEX_METRIKA_ID_KEY},
      {key: YANDEX_METRIKA_PORTAL_KEY}
    ]),
    activateTop100({key: TOP100_KEY})
  ])
}
